import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { environment } from './../../../environments/environment';

@Directive({ selector: '[imgSrc]' })
export class ImgSrcDirective implements OnInit {
  @Input() imgSrc: string;
  @Input() cdnLink: boolean;
  elem: ElementRef;

  constructor(el: ElementRef) {
    this.elem = el;
  }

  ngOnInit() {
    if (this.cdnLink) {
      this.elem.nativeElement.src = environment.cdnURL + this.imgSrc;
    } else {
      this.elem.nativeElement.src = environment.uiTemplateBaseUrl + this.imgSrc;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/img-src.directive.ts